<template>
  <div>
    <v-card
      flat
      class="container--fluid bg-gray no-margins elevation-1 not-rounded"
    >
      <v-skeleton-loader
        v-bind="headerAttrs"
        type="heading, actions"
      ></v-skeleton-loader>
    </v-card>
    <v-skeleton-loader
      v-bind="elementAttrs"
      type="heading"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-bind="elementAttrs"
      type="heading"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-bind="elementAttrs"
      type="heading"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-bind="elementAttrs"
      type="heading"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-bind="elementAttrs"
      type="heading"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-bind="elementAttrs"
      type="heading"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-bind="elementAttrs"
      type="heading"
    ></v-skeleton-loader>
    <v-skeleton-loader
      v-bind="elementAttrs"
      type="heading"
    ></v-skeleton-loader>
  </div>
</template>

<script>
// @group Application
export default {
  name: 'ApplicationLoader',

  props: {},

  data: () => ({
    headerAttrs: {
      class: 'pa-4',
      height: '102px'
      // boilerplate: true
      // elevation: 2
    },
    elementAttrs: {
      class: 'ma-6 pa-5',
      elevation: 2
    }
  })
}
</script>

<style>
</style>